import { useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom-v5-compat";
import { useMyMealsMenuContext } from "../../../../MyMeals/MyMealsMenuContext/MyMealsMenuContext";
import { groupOrdersByProgramAndSeparateBySubscription, handleClick, handleClose, } from "../MyMealsMenu/utils/myMealsMenu-utils";
import { AccountRoutesType } from "../navigationUtils";
import { useCustomerOrdersQuery } from "../../../../SWR/CustomerOrders/useCustomerOrdersQuery";
// ==================== MY MEALS MENU LOGIC HOOK ====================
// Custom hook that encapsulates logic for handling My Meals menu functionality.
export const useMyMealsMenu = (isNavDrawer) => {
    const theme = useTheme(); // MUI theme for styling menu items.
    const location = useLocation(); // Current location from React Router.
    const { selectedSubLinkId, setSelectedSubLinkId } = useMyMealsMenuContext(); // Access the selected sub-link context.
    //* ===== SWR ORDERS QUERY =====
    const { data, error, isLoading, isValidating } = useCustomerOrdersQuery(); // Fetch orders data using SWR.
    const [anchorEl, setAnchorEl] = useState(null); // Holds the reference for menu anchor element (used to control menu open/close).
    const isMyMealsPage = location.pathname === AccountRoutesType.MY_MEALS;
    // For the nav drawer.
    const [isMyMealsNavDrawerMenuOpen, setIsMyMealsNavDrawerMenuOpen] = useState(isMyMealsPage && isNavDrawer ? true : false);
    // For the nav bar.
    const open = Boolean(anchorEl); // Determines whether the menu is open or closed.
    // Styles for the menu items, conditionally applying based on the current path.
    const menuStyles = isMyMealsPage
        ? {
            textDecoration: "underline",
            textDecorationThickness: "2px",
            textUnderlinePosition: "under",
            textUnderlineOffset: "2px",
            textDecorationColor: theme.palette.primary.main,
            color: theme.palette.common.black, // Black text for emphasis.
        }
        : {
            color: theme.palette.grey[`A700`], // Greyed out if the user is not on 'My Meals'.
        };
    // TODO - Consider improving this logic with React Router navigation hooks.
    useEffect(() => {
        let mounted = true; // Track if the component is still mounted.
        // ** Reset selectedSubLinkId if navigating away from 'My Meals' and a sub-link is currently selected.
        if (mounted && !isMyMealsPage && !!selectedSubLinkId) {
            setSelectedSubLinkId(undefined); // Clear selection when navigating away.
        }
        // Cleanup function to avoid state updates when the component is unmounted.
        return () => {
            mounted = false;
        };
    }, [location.pathname]);
    const orders = groupOrdersByProgramAndSeparateBySubscription(data === null || data === void 0 ? void 0 : data.orders);
    return {
        anchorEl,
        handleClick: handleClick(setAnchorEl),
        handleClose: handleClose(setAnchorEl, setSelectedSubLinkId),
        loading: isLoading,
        menuStyles,
        open,
        orders,
        isMyMealsNavDrawerMenuOpen,
        setIsMyMealsNavDrawerMenuOpen,
        isMyMealsPage,
    };
};
